<template>
  <!-- 工作台我的项目模块 -->
  <div id="my-project">
    <div class="top">
      <!-- 搜索项目和导入项目 -->
      <div class="left">
        <a-input-search v-model="searchKey" class="searchProject" :placeholder="$t('project.inputSearchKeywords')" size="large" @search="getSandList" allowClear/>
      </div>
      <!-- 项目列表排序和刷新 -->
      <div class="right">
        <!-- <SortField @handSortCheck="handSortCheck"></SortField> -->
        <a-dropdown>
          <span style="cursor: pointer">
            {{$t(sortField)}} <img class="arrow-icon" src="@/assets/home/arrow-down.png"/>
          </span>
          <a-menu slot="overlay" @click="timeSortClick">
            <a-menu-item key="desc">
              <a href="javascript:;">{{$t('project.newestTime')}}</a>
            </a-menu-item>
            <a-menu-item key="asc">
              <a href="javascript:;">{{$t('project.earliestTime')}}</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
        <div class="refresh" @click="refreshList">
          <a-tooltip placement="top">
            <template slot="title">
              <span>{{$t('project.refreshList')}}</span>
            </template>
            <a-icon size="16px" type="reload" :spin="refreshing" />
          </a-tooltip>
        </div>
      </div>
    </div>
    <!-- 项目列表 -->
    <div class="scrollbar">
      <a-spin :spinning="loading" class="loading-spin" size="large"></a-spin>
      <div class="projectList">
        <AuthControl code="create_sandbox">
          <div class="createProject card" @click="isCreateSand = true">
              <div class="icon"><a-icon type="plus" /></div>
              <div class="text">{{$t('project.newSandbox')}}</div>
          </div>
        </AuthControl>
        <Project v-for="item in sanList" :key="item.id" :project="item" class="card" @refreshSandList="refreshList" />
      </div>
    </div>
    <!-- 分页组件独占一行 -->
    <div class="pagination-container">
      <a-pagination
        v-if="pagination.total !== 0"
        :total="pagination.total"
        :show-total="total => $t('project.total', { total })"
        :show-size-changer="true"
        @change="pageNumChange"
        @showSizeChange="pageSizeChange"/>
    </div>
    <!-- 创建沙盘 -->
    <CreateSandModal :createSandVisible.sync="isCreateSand" @refreshSandList="refreshList"></CreateSandModal>
  </div>
</template>

<script>
import Project from './project.vue'
// import SortField from './components/sort-field/index.vue'
import { getProjectList } from '@/api/workbench'
import CreateSandModal from './components/CreateSandModal.vue'  
export default {
  components: {
    Project,
    // SortField,
    CreateSandModal,
  },
  data() {
    return {
      loading: false,
      searchKey:'',
      isCreateSand: false, // 创建沙盘
      refreshing:false,
      sanList: [],
      sortField: 'project.newestTime',
      pagination: {
        pageSize: 10,
        pageIndex: 1,
        total: 0,
      },
      sortInfo: {
        sortField: 'updateTime',
        sortOrder: 'desc',
      },
    }
  },
  computed: {
    userId() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
      return userInfo.applyAccount || userInfo.userId || null
    },
  },
  mounted() {
    this.getSandList()
  },
  methods: {
    searchProject() {
      this.getSandList()
    },
    // 排序字段选中的
    timeSortClick(e) {
      console.log(e)
      // this.sortInfo.sortField = e.key
      this.sortInfo.sortOrder = e.key
      this.pagination.pageIndex = 1
      this.sortField = e.key === 'desc' ? 'project.newestTime' : 'project.earliestTime'
      this.getSandList()
    },
    async getSandList() {
      try {
          this.loading = true
          const payload = {
          'account': this.userId, //必填，账户id
          'queryParam':{
            'searchKey': this.searchKey
          },
          'pageInfo':{
            'pageSize': this.pagination.pageSize, //必填，每页记录数
            'pageIndex': this.pagination.pageIndex //必填，页码 
          },
          'sortInfo': this.sortInfo
        }
        const res = await getProjectList(payload)
        if(res.code === 200 || res.status === 0){
          this.sanList = res.data.records
          this.pagination.total = res.data.total
        }
      } finally {
        this.loading = false
      }
    },
    pageNumChange(page) {
      this.pagination.pageIndex = page
      this.getSandList()
    },
    pageSizeChange(current, size) {
      this.pagination.pageIndex = 1
      this.pagination.pageSize = size
      this.getSandList()
    },
    refreshList(isFirst = false) {
      if(isFirst){
        this.pagination.pageIndex = 1
      }
      this.refreshing = true
      setTimeout(() => {
        this.getSandList()
        this.refreshing = false
      }, 500)
    }
  },
}
</script>

<style scoped lang="less">
#my-project {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 22px;
    .left,
    .right {
      display: flex;
      align-items: center;
      .arrow-icon{
        width: 16px;
        height: 16px;
        margin-right: 20px;
      }
    }
    .searchProject {
      width: 250px;
      margin-right: 16px;

      border-radius: 4px 4px 4px 4px;
    }
    .refresh {
      color: #fff;
      cursor: pointer;
    }
    .a-btn {
      border-radius: 4px;
    }
    .dropdown-button * {
      color: #fff;
    }
    .arco-btn-group > * {
      background-color: var(--body-bg-color);
    }
    :deep(.arco-btn-group .arco-btn-secondary:not(:last-child)) {
      border-right: none;
      padding-right: 0;
      cursor: default;
    }
    :deep(.arco-btn-size-medium.arco-btn-only-icon) {
      width: 16px;
      height: 16px;
      margin: auto 17px auto 4px;
    }
  }
  .scrollbar {
    width: 100%;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    position: relative;
    .loading-spin{
      position: absolute;
      z-index: 1000;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%)
    }
    // 自定义滚动条样式
    &::-webkit-scrollbar {
      display: block;
      width: 8px;
    }
    
    &::-webkit-scrollbar-track {
      background: rgba(255, 255, 255, 0.05);
      border-radius: 4px;
    }
    
    &::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.2);
      border-radius: 4px;
      transition: background 0.3s ease;
    }
    
    &::-webkit-scrollbar-thumb:hover {
      background: rgba(255, 255, 255, 0.4);
    }
  }
  .projectList {
    display: grid;
    grid-template-columns: repeat(auto-fit, 303px);
    gap: 25px 30px;
    justify-content: start;
    .card {
      width: 301px;
      height: 250px;
      background-color: #29292c;
      border-radius: 8px;
      cursor: pointer;
      font-family: PingFang SC, PingFang SC;
      font-size: 14px;
      border: 1px solid #484849;
      &:hover {
        border-color: #0166fc;
      }
    }
    .createProject {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .icon {
        font-size: 24px;
        margin-bottom: 13px;
      }
    }
  }
}

// 分页组件独占一行的样式
.pagination-container {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 20px;
  background-color: transparent;
}

/deep/ input.ant-input.ant-input-lg {
  background: #2e2e2e;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  // color: #5c5e65;
  border: 0px;
}
/deep/ i.anticon.anticon-search.ant-input-search-icon {
  color: #fff;
}
</style>
